<template>
  <policy
    title="Informacja o przetwarzaniu danych osobowych"
    :policy="templates[T.Gdpr.CONTENT]"
    :state="actions.templates"
  />
</template>

<script>
import Policy from "%components/policy/Policy";

import T from "%const/templates";

import { WithTemplates } from "%mixins";

export default {
  name: "gdpr-policy",

  mixins: [
    WithTemplates({
      templates: [T.Gdpr.CONTENT]
    })
  ],

  components: {
    Policy
  },

  mounted() {
    this.requestTemplates();
  },

  data() {
    return { T };
  }
};
</script>

<style></style>
